import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/images/phone.webp';
import _imports_1 from '../../assets/images/chat.webp';
import _imports_2 from '../../assets/images/ucTop.webp';
const _withScopeId = n => (_pushScopeId("data-v-498512b2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "fixed-right"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "PHONE", -1));
const _hoisted_4 = [_hoisted_2, _hoisted_3];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "CHAT", -1));
const _hoisted_7 = [_hoisted_5, _hoisted_6];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1));
const _hoisted_9 = [_hoisted_8];
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tip"
}, " You can get exclusive services by our representative from ", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "phone"
}, "+44 1315070088", -1));
const _hoisted_12 = [_hoisted_10, _hoisted_11];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: "img-button chickable",
    onClick: [_cache[0] || (_cache[0] = $event => $options.phone()), _cache[1] || (_cache[1] = _withModifiers((...args) => $options.handleClickOnButton && $options.handleClickOnButton(...args), ["stop"]))]
  }, _hoisted_4), _createElementVNode("div", {
    class: "img-button chickable",
    onClick: _cache[2] || (_cache[2] = $event => $options.chat()),
    id: "ukTool",
    style: {
      "border-top": "1px solid #ffffff"
    }
  }, _hoisted_7), _createElementVNode("div", {
    class: "img-button chickable",
    onClick: _cache[3] || (_cache[3] = $event => $options.top()),
    style: {
      "border-top": "1px solid #ffffff"
    }
  }, _hoisted_9)]), _withDirectives(_createElementVNode("div", {
    class: "speech-bubble",
    onClick: _cache[4] || (_cache[4] = _withModifiers((...args) => $options.handleClickOnButton && $options.handleClickOnButton(...args), ["stop"]))
  }, _hoisted_12, 512), [[_vShow, $data.showPhone]])], 64);
}